import React from "react";
import Select from "react-select";
import "../resources/stylesheets/genericUrls.css";

export const LanguageSelect = ({ languages, handleLanguageChange }) => {
  const options = [];

  if (languages && languages.length > 0) {
    languages.forEach((l) => {
      options.push({
        value: l.languageCode,
        label: l.name,
      });
    });
  }

  return (
    <Select
      defaultValue={{ value: "es", label: "Español" }}
      options={options}
      onChange={(e) => {
        handleLanguageChange(e);
      }}
      className="langSelect"
    />
  );
};
